import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyHeading, MyGlobal, MyAlert } from '../GlobalContext';

export class LH_UpdateHoldLocation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: this.props.show,
            loading: false,
            alertMessage: "",
            sscc: "",
            oldLocation:"",
            newLocation:""
        };

    }

    componentDidMount() {
        this.bindLocationData();
        this.refs.newlocInput.focus();
    }
    bindLocationData() {
        var locationData = this.props.updateLocationData;
        if (!locationData || !locationData.scannedSSCC || !locationData.scannedPutawayloc) {

            this.setState({ alertMessage: "SSCC and Location data not available" });
        }
        else {
            this.setState({ sscc: locationData.scannedSSCC, oldLocation: locationData.scannedPutawayloc });
        }
    }

    updateHoldLocation() {

        this.setState({ loading: true, alertMessage: "" });

        if (!this.state.newLocation || this.state.newLocation ==="") {
            this.setState({ loading: false, alertMessage: "Please scan the location" });
            this.refs.newlocInput.focus();
            return;
        }
        this.state.newLocation = this.state.newLocation.trim();
        var barCodeFormat = this.state.newLocation.split("-");
        if (!barCodeFormat || barCodeFormat.length !== 4) {
            this.setState({ loading: false, newLocation:"",  alertMessage: "Invalid Location!! Location should be of this format : Stage-01-01-09" });
            this.refs.newlocInput.focus();
            return;
        }

        if (!this.state.sscc || this.state.sscc === "") {
            this.setState({ loading: false, alertMessage: "SSCC details not available" });
            return;
        }
        if (!this.state.oldLocation || this.state.oldLocation === "") {
            this.setState({ loading: false, alertMessage: "Current location not available" });
            return;
        }
        var createNewHoldLocationRequest = {
            sscc: this.state.sscc,
            oldLocation: this.state.oldLocation,
            newLocation: this.state.newLocation
        };
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(createNewHoldLocationRequest)
        };

        fetch(`api/LinenhouseXdoc/CreateNewHoldLocation`, requestOptions)
            .then(async response => {

                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: errorText });
                    return;
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        if (apiResponse.success && apiResponse.data === true) {

                            this.setState({ alertMessage: "New hold location updated" });
                        }
                        else {
                            //TODO: Check with Bruce about the wording of this message
                            this.setState({ alertMessage: "Failed to update hold location!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to update hold location!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }
    render() {
        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        return (
            <>
                <Modal show={this.props.show} onHide={this.props.onClick} backdrop="static" centered>
                    <Modal.Header>
                        <Modal.Title>Enter hold new location</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {alertMessage}
                        <Container>
                            <Row className="mb-3">
                                <Col xs={3}>SSCC : </Col>
                                <Col xs={9}>
                                    <label>{this.state.sscc}</label>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col xs={3}>Current Location : </Col>
                                <Col xs={9}>
                                    <label>{this.state.oldLocation}</label>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col xs={3}>New Hold Location : </Col>
                                <Col xs={9}>
                                    <input ref="newlocInput" className="form-control" placeholder="New Location" value={this.state.newLocation}
                                        onChange={(e) => {
                                            this.setState({ newLocation: e.target.value });
                                        }}  readOnly={this.state.loading} >
                                    </input>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn btn-success col-12 mb-2" onClick={() => this.updateHoldLocation()}>
                            Update
                        </Button>
                        <Button className="btn btn-success col-12 mb-2" onClick={() => this.props.onClickClose(this.state.newLocation)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default LH_UpdateHoldLocation;